<template lang="html">
    <div class="flex-shrink-0" v-if="reveals.length > 0">
        <h3 class="h5 font-weight-bold mb-4">Cards drawn</h3>
        <ul
            ref="lobbyHistory"
            class="list-unstyled my-0 overflow-auto d-block"
            style="max-height: 168px;"
            v-chat-scroll="{ smooth: true }"
        >
            <li
                v-for="(history, i) in reveals"
                :key="i"
                class="d-flex align-items-center justify-content-between mb-3"
            >
                <div class="d-flex align-items-center">
                    <avatar
                        :name="history.player.name"
                        :colour="history.player.colour"
                        :width="40"
                        class="mr-3 ml-0"
                    ></avatar>
                    <small class="font-weight-bold">Card revealed</small>
                </div>
                <span
                    class="badge badge-light badge-pill d-flex"
                    :class="getCardColor(history.card.suit)"
                >
                    <div class="mr-1">
                        {{ getCardValue(history.card.value) }}
                    </div>
                    <div>{{ getCardSuit(history.card.suit) }}</div>
                </span>
            </li>
        </ul>
    </div>
</template>

<script>
import cards from '@/mixins/cards';
import Avatar from '@/components/Avatar';

export default {
    mixins: [cards],
    components: {
        Avatar,
    },
    computed: {
        reveals() {
            return this.$store.state.room.history.filter(
                (i) => i.type === 'card_revealed',
            );
        },
    },
};
</script>

<style lang="css"></style>
